import React, { useEffect, useState } from "react";
import StickyTitle from '../components/StickyTitle'
import ReactToPrint from "react-to-print";
import {
    InputLabel,
    FormControl,
    Button,
} from "@mui/material";
import companylogo from "../../assets/company.png"

import Select from 'react-select'

const ReportItemSales = () => {

    const [invoicedata, setInvoicedata] = useState();
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [category, setCategory] = useState(null)
    const [categoryData, setCategoryData] = useState(null)
    const [client, setClient] = useState(null)
    const [clientData, setClientData] = useState([])
    const [salesman, setSalesman] = useState(null)
    const [salesmanData, setSalesmanData] = useState([])

    //Item Prod
    const [FilteredInvoiceDataProd, setFilteredInvoiceDataProd] = useState('')
    const [filteredInvoiceDataItem, setFilteredInvoiceDataItem] = useState('')


    const componentRef = React.createRef();

    useEffect(() => {
        const fetchInvoiceData = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_BASE_URL}/invoices/all_invoices`
                );
                const responseData = await response.json();
                if (responseData) {
                    setInvoicedata(responseData.invoice)
                }

            } catch (error) {
                console.log(error.message);
            }
        };

        fetchInvoiceData();


        // fetch category

        const fetchCategory = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/category/all_categories`);
                const responseData = await response.json();
                if (responseData) {
                    const temp = responseData.categories?.map((cat)=>
                    ({value:cat.id, label:`${cat.categoryname} ID: ${cat.id}`})
                    )
                    setCategoryData(temp)
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
        fetchCategory();

        // fetch clients

        const fetchClients = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/clients/all_clients`);
                const responseData = await response.json();
                if (responseData) {
                    const temp = responseData.client?.map((client)=>
                    ({value:client.id, label:`${client.companyname} ID: ${client.id}`})
                    )
                    setClientData(temp)
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
        fetchClients();

        // fetch salesmen

        const fetchSalesmen = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_BASE_URL}/salesman/all_salesmen`
                );
                const responseData = await response.json();
                if (responseData) {
                    const temp = responseData.salesmen?.map((salesman)=>
                    ({value:salesman.id, label:`${salesman.fullname} ID: ${salesman.id}`})
                    )
                    setSalesmanData(temp)
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
        fetchSalesmen();

    }, []);

    useEffect(() => {
        let filteredData = invoicedata;

        if (fromDate && toDate) {
            filteredData = filteredData.filter(payment => payment.issuedate >= fromDate && payment.issuedate <= toDate);
        }

        if(category) {
            filteredData = filteredData.filter(payment => payment.categoryId === category.value);
        }

        if(salesman) {
            
            filteredData = filteredData.filter(payment => payment.salesmanid == salesman.value);
        }

        if(client) {
            filteredData = filteredData.filter(payment => payment.clientid == client.value);
        }

        // let groupedItems = {};

        // filteredData.forEach(objItem => {
        //     objItem.list.forEach(item => {
        //         const amount = parseFloat(item.amount);
        //         if (!groupedItems[item.itemcode]) {
        //             groupedItems[item.itemcode] = { itemcode: item.itemcode, amount: 0, itemdesc:item.itemdesc };
        //         }
        //         groupedItems[item.itemcode].amount += amount;
        //     });
        // });
        
        
        // console.log(Object.values(groupedItems));


        const itemData = filteredData?.map(objItem => ({
            ...objItem,
            list: objItem.list?.filter(item => item.type === "Item")
        }));

        let groupedItems = {};

        itemData?.forEach(objItem => {
            objItem.list.forEach(item => {
                const amount = parseFloat(item.amount);
                if (!groupedItems[item.itemcode]) {
                    groupedItems[item.itemcode] = { itemcode: item.itemcode, amount: 0, itemdesc:item.itemdesc };
                }
                groupedItems[item.itemcode].amount += amount;
            });
        });
        
        
        console.log(Object.values(groupedItems));
        
        setFilteredInvoiceDataItem(Object.values(groupedItems))

        const prodData = filteredData?.map(objItem => ({
            ...objItem,
            list: objItem.list?.filter(item => item.type === "product")
        }));
        console.log(prodData)

        let groupedItems2 = {};

        prodData?.forEach(objItem => {
            objItem.list.forEach(item => {
                const amount = parseFloat(item.amount);
                if (!groupedItems2[item.itemcode]) {
                    groupedItems2[item.itemcode] = { itemcode: item.itemcode, amount: 0, itemdesc:item.itemdesc };
                }
                groupedItems2[item.itemcode].amount += amount;
            });
        });
        console.log(prodData)
        console.log(Object.values(groupedItems2));

        setFilteredInvoiceDataProd(Object.values(groupedItems2))

    }, [invoicedata, fromDate, toDate, category, salesman, client]);

    const calculateTotalPayments = (payments) => {
        return payments && payments?.reduce((total, payment) => total + parseInt(payment.total), 0);
    };

    return (
        <>
            <StickyTitle no_button={true} title="Item/Prod Sales Reports" />
            <div className=' px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>

                <div className="table-filters flex flex-col md:flex-row items-start md:items-center justify-center md:justify-between mt-3 mb-">
                    <div className='text-2xl ml-2 font-bold font-poppins'>Item/Product Sales Report</div>
                </div>
                <main className="m-5 p-5 xl:grid grid-cols-1 gap-10 xl:items-start">
                    <section>
                        <div className="bg-white p-5 rounded shadow">
                            <div className="flex flex-col justify-center">
                                <Button onClick={() => {
                                    setFromDate('')
                                    setFromDate('')
                                    setCategory('')
                                    setSalesman('')
                                    setClient('')
                                }} variant="contained" disableElevation>
                                    Clear Filters
                                </Button>
                                <div className="my-5">
                                <InputLabel>Filter Category</InputLabel>
                                    <Select
                                        value={category}
                                        onChange={(selectedOption) => setCategory(selectedOption)}
                                        options = {categoryData}
                                        isClearable={true}
                                    />  
                                </div>

                                <div className="my-5">
                                <InputLabel>Filter Client</InputLabel>
                                    <Select
                                        value={client}
                                        onChange={(selectedOption) => setClient(selectedOption)}
                                        options = {clientData}
                                        isClearable={true}
                                    />  
                                </div>

                                <div className="my-5">
                                <InputLabel>Filter Salesman</InputLabel>
                                    <Select
                                        value={salesman}
                                        onChange={(selectedOption) => setSalesman(selectedOption)}
                                        options = {salesmanData}
                                        isClearable={true}
                                    />  
                                </div>
                               
                                <InputLabel>From Date</InputLabel>
                                <FormControl>
                                    <input type="date" onChange={(e) => setFromDate(e.target.value)} />
                                </FormControl>
                                <InputLabel>To Date</InputLabel>
                                <FormControl>
                                    <input type="date" onChange={(e) => setToDate(e.target.value)} />
                                </FormControl>
                                                                              
                                        
                                <ReactToPrint
                                    trigger={() => (
                                        <button className="bg-green-500 mt-5 text-white font-bold py-2 px-4 rounded hover:bg-green-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-green-400">
                                            Generate Report
                                        </button>
                                    )}
                                    content={() => componentRef.current}
                                />
                            </div>
                        </div>
                    </section>

                    <div className="invoice__preview bg-white p-5 rounded-2xl border-4 border-blue-200  ">
                        <ReactToPrint
                            trigger={() => (
                                <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                                    Print / Download
                                </button>
                            )}
                            content={() => componentRef.current}
                        />
                        <div
                            ref={componentRef}
                            className="py-5 px-8 flex flex-col min-h-full print:w-[210mm] print:h-[100mm] relative"
                        >
                            <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                                <div>

                                    <img  src={companylogo} alt="logo" />
                                </div>
                            </div>
                            <article className=" py-2 text-center text-base text-black border-t border-black uppercase w-full font-bold">
                                <p>Item/Product Sales Report</p>
                            </article>

                            <table width="100%" className="mb-10">
                                <thead>
                                    <tr className=" text-center bg-gray-100 p-1 py-2 text-base text-black border-t border-b border-black uppercase w-full font-semibold">
                                        <td className="font-bold">Code</td>
                                        <td className="font-bold">Description</td>
                                        <td className="font-bold">Total Sale</td>
                                        
                                    </tr>
                                </thead>
                                <InputLabel className=" ml-2 mt-2 italic text-base">Item Sales</InputLabel>
                                <tbody  className=" border-t border-b border-gray-400">
                                    {filteredInvoiceDataItem && filteredInvoiceDataItem?.map((invoice) => (
                                        <tr className=" text-center h-10" key={invoice.itemcode}>
                                            <td>{invoice.itemcode}</td>
                                            <td>{invoice.itemdesc}</td>
                                            <td>{invoice.amount}</td>
                                         
                                        </tr>
                                    ))}
                                </tbody>
                                <InputLabel className=" ml-2 mt-2 italic text-base">Prod Sales</InputLabel>
                                <tbody className=" border-t border-gray-400">
                                    {FilteredInvoiceDataProd && FilteredInvoiceDataProd?.map((invoice) => (
                                        <tr className=" text-center h-10" key={invoice.itemcode}>
                                            <td>{invoice.itemcode}</td>
                                            <td>{invoice.itemdesc}</td>
                                            <td>{invoice.amount}</td>
                                            
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <tr className=" text-center bg-gray-100 p-1 py-2 mb-10 text-center text-base text-black border-t border-b border-black uppercase w-full font-semibold" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <td className=" font-bold text-md text-center" colSpan={2}>
                                    Total Sales: {calculateTotalPayments(filteredInvoiceData)}
                                </td>
                            </tr> */}
                            <tr className=" text-center h-10 font-bold mt-2">
                                <td className=" font-bold text-lg border-t border-black text-center" colSpan={2}>
                                    Accountant
                                </td>
                            </tr>


                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default ReportItemSales